// extracted by mini-css-extract-plugin
export default {"content":"ylkbT","button":"xVaux","textWrapper":"xjkEL","text":"DtyWw","price":"ZfdQ2","arrow":"BkURe","popoverInfo":"BeHKo","popover":"b90Ci"};